export default {
  title: "Esta página no ha sido generada",
  subtitle: "Cuéntame más sobre esta página para poder generarla",
};